module.exports = __webpack_public_path__ + "static/fonts/Mont-Thin.71e7648.woff2";